import { render, staticRenderFns } from "./aggregateCollection.vue?vue&type=template&id=16259b6a&"
import script from "./aggregateCollection.vue?vue&type=script&lang=js&"
export * from "./aggregateCollection.vue?vue&type=script&lang=js&"
import style0 from "./aggregateCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports